/**
 * SKEMA Business School white-labelling.
 *
 * Consumers swap the Libertify wordmark for the SKEMA logo when the content
 * belongs to a SKEMA organization — in admin that's the creator's org, in
 * media-player the publication's owning org (the viewer is anonymous there,
 * so the publication is the only available signal).
 *
 * Nothing in the API carries a tenant logo today (`Palette` is colors only),
 * so the mapping lives in code. One entry per environment, since the org is
 * created separately in each.
 */
export const SKEMA_ORGANIZATION_IDS = ['skema', 'skema-dev'];

/** True when the given organization should be branded as SKEMA. */
export const isSkemaOrganization = (organizationId?: string | null): boolean =>
  organizationId != null && SKEMA_ORGANIZATION_IDS.includes(organizationId);
